// src/features/links/CopyButton.tsx
// IR-1047 Phase 3.5 — copy-to-clipboard button (Rotem QA: a copy button next to
// each link). Small, reusable; shows a transient "Copied" state on success.
import { useState } from "react";

interface Props {
  text: string;
  label?: string;
}

export function CopyButton({ text, label = "Copy link" }: Props) {
  const [copied, setCopied] = useState(false);

  async function onCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API unavailable (insecure context / denied) — no-op.
    }
  }

  return (
    <button
      type="button"
      aria-label={label}
      title={copied ? "Copied" : label}
      onClick={onCopy}
      className="shrink-0 rounded px-1 text-xs text-[var(--iris-fg-4)] hover:text-[var(--iris-fg-1)]"
    >
      {copied ? "✓" : "⧉"}
    </button>
  );
}
